import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  
  const currentLang = languages.find(lang => lang.code === language);

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-gray-200 hover:border-pink-300"
        style={{ transition: 'all 0.2s' }}
        data-testid="language-toggle-btn"
      >
        <Globe className="w-5 h-5 text-gray-600" />
        <span className="text-2xl">{currentLang?.flag}</span>
        <span className="hidden sm:inline text-gray-700 font-medium">{currentLang?.name}</span>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div
            className="absolute right-0 mt-2 w-48 rounded-xl bg-white shadow-lg border border-gray-200 overflow-hidden z-50"
            data-testid="language-dropdown"
          >
            {languages.map((lang) => (
              <button
                key={lang.code}
                data-testid={`lang-${lang.code}`}
                onClick={() => {
                  setLanguage(lang.code);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-pink-50 ${
                  language === lang.code ? 'bg-pink-100' : ''
                }`}
                style={{ transition: 'background 0.2s' }}
              >
                <span className="text-2xl">{lang.flag}</span>
                <span className="font-medium text-gray-700">{lang.name}</span>
                {language === lang.code && (
                  <span className="ml-auto text-pink-500">✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
